import React from 'react';
import DocumentMeta from 'react-document-meta';
import { connect } from 'react-redux';
import {Link} from 'react-router-dom';
import DOMPurify from 'dompurify';
import {AdSlot, DFPManager} from 'react-dfp';
import styled from 'styled-components';
import ReactEcharts from './ReactECharts';
import Loading from './Loading';
import {getRaceDetails, selectEvent, getRunnerResults, toggleFavorite, switchRace} from '../actions/race';
import AddFavoriteIcon from '../icons/add-favorite';
import RemoveFavoriteIcon from '../icons/remove-favorite';
import StarIcon from '../icons/star';

class Runner extends React.Component {

  constructor(props, context) {
    super(props, context);

    window.certLoaded = this.certLoaded.bind(this);
  }

  state = {
    selectedTab: 'results',
    loading: true,
    notFound: false,
    showCertLoading: true
  };

  certLoaded() {
    this.setState({showCertLoading: false});
  }

  componentWillMount() {

    if (this.props.match.params.raceId) {
      this.props.getRaceDetails(this.props.match.params.raceId);
      this.props.selectEvent(this.props.match.params.eventId);
      this.props.getRunnerResults(this.props.match.params.raceId, this.props.match.params.eventId, this.props.match.params.bib);
    }

  }
  componentWillReceiveProps(nextProps){

    if(nextProps.runnerResult && nextProps.runnerResult.$KEY === nextProps.match.params.bib) {
      this.setState({loading: false});
    }

    if(nextProps.runnerResult && nextProps.runnerResult.$KEY === undefined) {
      this.setState({notFound: true, loading: false});
    }

    if (this.props.match.params.raceId !== nextProps.match.params.raceId) {
      this.props.switchRace(nextProps.match.params.raceId);
      this.setState({selectedTab: 'results'});
    }
    if (this.props.match.params.raceId !== nextProps.match.params.raceId || this.props.match.params.eventId !== nextProps.match.params.eventId) {
      this.props.selectEvent(nextProps.match.params.eventId);
    }

    if (this.props.match.params.raceId !== nextProps.match.params.raceId || this.props.match.params.eventId !== nextProps.match.params.eventId || this.props.match.params.bib !== nextProps.match.params.bib) {
      const _this = this;
      this.setState({loading: true}, () => {
        _this.props.getRunnerResults(nextProps.match.params.raceId, nextProps.match.params.eventId, nextProps.match.params.bib);
      });

    }
  }

  componentDidUpdate() {
    if (this.props.raceDetail && this.props.raceDetail.name && this.props.runnerResult) {
      const name = this.props.runnerResult.$TEAM_NAME || `${this.props.runnerResult.$FIRST_NAME} ${this.props.runnerResult.$LAST_NAME}`;
      document.title = `RaceResults 360 - ${this.props.raceDetail.name} - ${name}`;
    }
  }

  componentDidMount() {
    // console.log('DFPing!');
    DFPManager.load(["below-runner-results"]);
  }


  toggleFavorite(runner, fav) {
    this.props.toggleFavorite(runner, fav);
  }

  selectTab(tab) {
    this.setState({selectedTab: tab});
  }


  getPieData(num, denom) {

    return {
      title: {
        show: true,
        text: parseInt((num/denom)*100) + '%',
        right: 0,
        textStyle: {color: this.props.color}
      },
      tooltip: {show: false},
      legend: {show: false},
      series: [{
        type: 'pie',
        center: ['25%', '50%'],
        radius : '65%',
        silent: true,
        data: [
          {value: num, itemStyle : {normal : {color: this.props.color, label : {show : true}, labelLine : {show : false}}}},
          {value: denom-num, itemStyle : {normal : {color: '#C7C8C9', label : {show : false}, labelLine : {show : false}}}}
        ]
      }]
    };
  }



  render() {

    const chartStyle = {height: '54px', width: '80px', display: 'inline-block',     verticalAlign: 'middle'};

    const {raceDetail} = this.props;

    const runnerResult = Object.assign({}, this.props.runnerResult);
    Object.keys(runnerResult).map((key, idx) => {
      if (key !== 'MAPPINGS') {
        runnerResult[key] = DOMPurify.sanitize(runnerResult[key]);
      }
    });

    const meta = {
      title: document.title,
      description: `Online Race Results for ${runnerResult.$FIRST_NAME || ''} ${runnerResult.$LAST_NAME || ''} in the ${raceDetail.name} ${raceDetail.event_type} event. Powered by RaceResults 360.`,
      canonical: location.href,
      meta: {
        charset: 'utf-8',
        name: {
          keywords: `raceresults360,${raceDetail.name},${raceDetail.event_type},${raceDetail.city},${raceDetail.state},${raceDetail.country},athletes,runners,triathletes`
        }
      }
    };



    const isFavorite = runnerResult && this.props.favorites && this.props.favorites.filter(x => x.$KEY === runnerResult.$KEY).length > 0;

    // console.log(runnerResult);
    // console.log(raceDetail);

    if (this.state.loading || !runnerResult) {
      return (
        <Loading />
      );
    }

    if (this.state.notFound) {
      return (
        <div>
          <DocumentMeta {...meta} />
          <div className="header">
            <h5 className="title" style={{backgroundColor: this.props.color}}>{raceDetail.name}</h5>

            <div className="info-block clearfix">
              <h3>Athlete</h3>

              <a href={`#/race/${raceDetail.race_id}`} className="btn menubutton">Menu</a>
            </div>
          </div>
          <div className="block-wrap">
            <div className="block clearfix">
              <div className="block-text">
                Participant not found.
              </div>
            </div>
          </div>
        </div>
      );
    }

      return (
        <div>
          <DocumentMeta {...meta} />
          <div className="header">
            <h5 className="title" style={{backgroundColor: this.props.color}}>{raceDetail.name}</h5>

            <div className="info-block clearfix">
              <h3>Athlete</h3>

              <a href={`#/race/${raceDetail.race_id}`} className="btn menubutton">Menu</a>
            </div>
          </div>
          <div className="block-wrap">
            <div className="block clearfix">
              <div className="block-text">
                <h4>
                  {runnerResult.$TEAM_NAME ? (
                    runnerResult.$TEAM_NAME
                  ) : (
                    `${runnerResult.$FIRST_NAME} ${runnerResult.$LAST_NAME}`
                  )}
                  <span>Bib: {runnerResult.$KEY}</span>
                </h4>
              </div>
              <div className="block-btns">
                <a id="toggle-favorite" onClick={this.toggleFavorite.bind(this, runnerResult, !isFavorite)}>
                  {isFavorite ?
                    <RemoveFavoriteIcon width={'72px'} height={'72px'} />
                   :
                    <AddFavoriteIcon />
                  }
                </a>
              </div>
            </div>

            {runnerResult.$TEAM_NAME &&
            <div className="section">
              {(runnerResult.$TM1_FIRST || runnerResult.$TM1_LAST) && <p><strong>{`${runnerResult.$TM1_FIRST} ${runnerResult.$TM1_LAST}`}</strong></p>}
              {(runnerResult.$TM2_FIRST || runnerResult.$TM2_LAST) && <p><strong>{`${runnerResult.$TM2_FIRST} ${runnerResult.$TM2_LAST}`}</strong></p>}
              {(runnerResult.$TM3_FIRST || runnerResult.$TM3_LAST) && <p><strong>{`${runnerResult.$TM3_FIRST} ${runnerResult.$TM3_LAST}`}</strong></p>}
              {(runnerResult.$TM4_FIRST || runnerResult.$TM4_LAST) && <p><strong>{`${runnerResult.$TM4_FIRST} ${runnerResult.$TM4_LAST}`}</strong></p>}
              {(runnerResult.$TM5_FIRST || runnerResult.$TM5_LAST) && <p><strong>{`${runnerResult.$TM5_FIRST} ${runnerResult.$TM5_LAST}`}</strong></p>}
            </div>
              }

            <div className="section">
              <p><strong>City, State:</strong> {runnerResult.$CITY && (<span>{runnerResult.$CITY} </span>)} {runnerResult.$STATE && (<span>{runnerResult.$STATE}</span>)}</p>
              <p><strong>Division:</strong> {runnerResult.$DIV || ''}</p>
              <br />
              <p><strong>Division Place:</strong> {runnerResult.$DIV_PLACE || ''}{runnerResult.$DIV_TOTAL ? `/${runnerResult.$DIV_TOTAL}` : ''}</p>
              <p><strong>Gender Place:</strong> {runnerResult.$GENDER_PLACE || ''}{runnerResult.$GENDER_TOTAL ? `/${runnerResult.$GENDER_TOTAL}` : ''}</p>
              <p><strong>Overall Place:</strong> {runnerResult.$OVERALL || ''}{runnerResult.$OVERALL_TOTAL ? `/${runnerResult.$OVERALL_TOTAL}` : ''}</p>
            </div>
          </div>

          <div className="table-info">
            <table width="100%" border="0" cellSpacing="0" cellPadding="0">
              <thead>
                <tr>
                  <th>Location</th>
                  <th>Time</th>
                  <th>Pace</th>
                </tr>
              </thead>
              <tbody>

              {runnerResult && runnerResult.MAPPINGS && runnerResult.MAPPINGS.map((location, idx) => (
                <tr className={`${idx % 2 === 0 ? 'results-odd' : 'results-event'}`} key={idx}>
                  <td dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(location.location)}} />
                  <td dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(`${runnerResult[location.current_segment] || ''} ${location.distance ? `(${location.distance}${location.distance_unit})` : '' }`)}} />
                  <td dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(`${runnerResult[location.pace] || ''}${location.pace_unit ? `/${location.pace_unit}` : ''}`)}} />
                </tr>

              ))}</tbody>
            </table>
          </div>
          <br /><br />
        </div>
      );
  }
}

function mapStateToProps(state) {
  return {
    raceDetail: state.rr360.raceDetail,
    favorites: state.rr360.favorites,
    results: state.rr360.results,
    eventId: state.rr360.eventId,
    runnerResult: state.rr360.runnerResult,
    isMobile: state.rr360.isMobile,
    ads: state.rr360.ads,
    color: state.rr360.theme.primaryColor
  };
}


export default connect(mapStateToProps, {getRaceDetails, selectEvent, getRunnerResults, toggleFavorite, switchRace})(Runner);



// WEBPACK FOOTER //
// ./src/components/Runner.js